<template>
  <div class="service-mgmt">
    <div class="main-title">
      <p>服务管理</p>
    </div>
    <div class="main-body">
      <el-row style="margin-bottom: 20px;">
        <el-input
          style="width: 200px; margin-right: 20px"
          placeholder="请输入服务名称"
          v-model="condition"
          clearable
          ><template slot="prepend"
            ><span class="el-icon-search"></span>
          </template>
        </el-input>
        <el-button class="w100" type="primary" @click="queryRecordList"
          >查询</el-button
        >
        <el-button class="w100" type="primary" @click="handleAdd"
          >添加服务</el-button
        >
      </el-row>
      <el-table
        :data="recordList"
        highlight-current-row
        style="width: 100%"
        v-loading="loading"
        element-loading-text="数据处理中，请稍候..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column property="typeDesc" label="服务类型"></el-table-column>
        <el-table-column property="name" label="服务名称"></el-table-column>
        <el-table-column
          property="className"
          label="服务类名"
        ></el-table-column>
        <el-table-column
          property="packagingTypeDesc"
          label="打包类型"
        ></el-table-column>
        <el-table-column
          property="mainClassFullName"
          label="服务主类全名"
        ></el-table-column>
        <el-table-column
          property="logbackFileName"
          label="日志文件名"
        ></el-table-column>
        <el-table-column
          property="packagePath"
          label="打包路径"
        ></el-table-column>
        <el-table-column
          property="gitRepoAddress"
          label="git仓库地址"
        ></el-table-column>
        <el-table-column
          property="projectName"
          label="工程名称"
        ></el-table-column>
        <el-table-column
          property="moduleName"
          label="模块名称"
        ></el-table-column>
        <el-table-column property="moduleName" label="操作" width="200px">
          <template slot-scope="scope">
            <el-button
              class="w75"
              @click.native.prevent="handleEdit(scope.row)"
              type="primary"
              size="small"
              >编辑</el-button
            >
            <el-button
              class="w75"
              @click.native.prevent="handleDelete(scope.row.id)"
              type="info"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 10px">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          @current-change="handlePageChange"
          background
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      :title="editRecord.id ? '编辑服务' : '新增服务'"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-form ref="form" :model="editRecord" label-width="100px">
        <el-form-item label="服务类型">
          <el-select v-model="editRecord.type" placeholder="请选服务类型">
            <el-option
              v-for="item in picker.taskType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="打包类型">
          <el-select
            v-model="editRecord.packagingType"
            placeholder="请选择打包类型"
          >
            <el-option
              v-for="item in picker.packagingType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务名称">
          <el-input
            v-model="editRecord.name"
            placeholder="请输入服务名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="editRecord.packagingType == '1' && editRecord.type != '5'"
          label="服务类名"
        >
          <el-input
            v-model="editRecord.className"
            placeholder="请输入服务类名"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="editRecord.packagingType == '1' && editRecord.type != '5'"
          label="服务主类全名"
        >
          <el-input
            v-model="editRecord.mainClassFullName"
            placeholder="请输服务主类全名"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="editRecord.packagingType == '1' && editRecord.type != '5'"
          label="日志文件名"
        >
          <el-input
            v-model="editRecord.logbackFileName"
            placeholder="请输入日志文件名"
          ></el-input>
        </el-form-item>
        <el-form-item label="打包路径">
          <el-input
            v-model="editRecord.packagePath"
            placeholder="请输入打包路径"
          ></el-input>
        </el-form-item>
        <el-form-item label="git仓库地址">
          <el-input
            v-model="editRecord.gitRepoAddress"
            placeholder="请输入git仓库地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="工程名称">
          <el-input
            v-model="editRecord.projectName"
            placeholder="请输入工程名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="
            (editRecord.packagingType == '0' ||
              editRecord.packagingType == '1') &&
              editRecord.type != '5'
          "
          label="模块名称"
        >
          <el-input
            v-model="editRecord.moduleName"
            placeholder="请输入模块名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="w100" @click="dialogVisible = false">取 消</el-button>
        <el-button class="w100" type="primary" @click="handleCommit"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Utils from "../utils/utils";
export default {
  name: "serviceList",
  data() {
    return {
      token: Utils.getLocalStorage("token"),
      recordList: [],
      editRecord: {},
      loading: false,
      dialogVisible: false,
      picker: {
        taskType: [],
        packagingType: [],
      },
      condition: "",
      total: 0,
      beginIndex: 0,
      pageSize: 10,
      timer: null,
    };
  },
  mounted() {
    Utils.getPicker([
      {
        type: "2",
        name: "packagingType",
      },
      {
        type: "3",
        name: "taskType",
      },
    ]).then((result) => (this.picker = result.picker));
    this.queryRecordList();
  },
  watch: {
    condition() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.beginIndex = 0;
        this.queryRecordList();
      }, 500);
    },
  },
  methods: {
    handlePageChange(pageNum) {
      this.beginIndex = (pageNum - 1) * this.pageSize;
      this.queryRecordList();
    },

    handleAdd() {
      this.editRecord = {};
      this.dialogVisible = true;
    },

    handleEdit(row) {
      this.editRecord = { ...row };
      this.dialogVisible = true;
    },

    handleCommit() {
      if (!this.editRecord.type && this.editRecord.type != "0") {
        this.showErrorMessage("请选择服务类型");
        return;
      }
      if (!this.editRecord.packagingType && this.editRecord.type != "0") {
        this.showErrorMessage("请选择打包类型");
        return;
      }
      // war
      if (!this.editRecord.name && this.editRecord.type != "0") {
        this.showErrorMessage("请输服务名称");
        return;
      }
      if (!this.editRecord.packagePath && this.editRecord.packagePath != "0") {
        this.showErrorMessage("请输入打包路径");
        return;
      }
      if (!this.editRecord.projectName && this.editRecord.projectName != "0") {
        this.showErrorMessage("请输入工程名称");
        return;
      }
      if (this.editRecord.packagingType == 0) {
        if (!this.editRecord.moduleName && this.editRecord.moduleName != "0") {
          this.showErrorMessage("请输入模块名称");
          return;
        }
      } else if (this.editRecord.packagingType == 1) {
        if (this.editRecord.type != "5") {
          if (
            !this.editRecord.moduleName &&
            this.editRecord.moduleName != "0"
          ) {
            this.showErrorMessage("请输入模块名称");
            return;
          }
          if (
            !this.editRecord.mainClassFullName &&
            this.editRecord.mainClassFullName != "0"
          ) {
            this.showErrorMessage("请输入主类全名");
            return;
          }
          if (
            !this.editRecord.logbackFileName &&
            this.editRecord.logbackFileName != "0"
          ) {
            this.showErrorMessage("请输入日志文件名");
            return;
          }
        }
      }
      this.createOrUpdate(this.editRecord);
    },

    createOrUpdate(params) {
      let self = this;
      self.loading = true;
      this.$http
        .post(
          "/admin/release/task/createOrUpdate",
          this.$qs.stringify(params),
          {
            headers: {
              token: this.token,
            },
          }
        )
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "操作失败!");
            return;
          }
          self.$message({
            type: "success",
            message: "操作成功",
            center: true,
          });
          self.dialogVisible = false;
          self.queryRecordList();
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    handleDelete(id) {
      this.$confirm("是否确认删除？").then(() => {
        this.delete(id);
      });
    },

    delete(id) {
      let self = this;
      self.loading = true;
      this.$http
        .get("/admin/release/task/delete?id=" + id, {
          headers: { token: this.token },
        })
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "操作失败!");
            return;
          }
          self.$message({
            type: "success",
            message: "操作成功",
            center: true,
          });
          self.queryRecordList();
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    queryRecordList() {
      let self = this;
      self.loading = true;
      this.$http
        .get(
          "/admin/release/task/list?" +
            this.$qs.stringify({
              condition: this.condition,
              beginIndex: this.beginIndex,
              pageSize: this.pageSize,
            }),
          {
            headers: { token: this.token },
          }
        )
        .then(function(response) {
          self.loading = false;
          let res = response.data;
          if (!res || !res.result) {
            self.showErrorMessage(res.message || "查询失败!");
            return;
          }
          self.recordList = res.ldata;
          self.total = res.mdata.total;
        })
        .catch(function(response) {
          self.loading = false;
        });
    },

    showErrorMessage(message) {
      if (message == "0000") {
        this.$message({
          type: "warning",
          message: "请先登录",
          center: true,
        });
      } else if (message == "0001") {
        this.$message({
          type: "warning",
          message: "未认证",
          center: true,
        });
      } else if (message == "0002") {
        this.$message({
          type: "warning",
          message: "无权限",
          center: true,
        });
      } else {
        this.$message({
          type: "error",
          message: message,
          center: true,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/serviceMgmt.vue